import { createApi } from "@reduxjs/toolkit/query/react";
import { CONFIG_VARS } from "../../constants/urlConstants/configuration";
import { createBaseQuery } from "../../shared/utils/baseQuery";

const { inmobiusJobBaseUrl, inmobiusJobApiVersion, apiKey } = CONFIG_VARS;

export const uploadMutation = createApi({
  reducerPath: "uploadMutation",
  baseQuery: createBaseQuery(inmobiusJobBaseUrl["1"], true), // Enable auth token
  endpoints: (builder) => ({
    bulkRegister: builder.mutation({
      query: ({ schoolId, formData }) => ({
        url: `${inmobiusJobApiVersion}/data-imports/bulk-register`,
        method: "POST",
        params: {
          school_id: schoolId,
        },
        body: formData,
        headers: {
          "product-id": "100",
        },
      }),
    }),
    bulkUpdate: builder.mutation({
      query: ({ schoolId, formData }) => ({
        url: `${inmobiusJobApiVersion}/data-imports/bulk-update`,
        method: "POST",
        params: {
          school_id: schoolId,
        },
        body: formData,
        headers: {
          "product-id": "1000",
        },
      }),
    }),
    getBulkRecordStatus: builder.query({
      query: (jobId) => ({
        url: `${inmobiusJobApiVersion}/data-imports/get-bulk-record-status`,
        method: "GET",
        params: {
          job_id: jobId,
        },
        headers: {
          "product-id": "1000",
        },
      }),
    }),
    getOfflineUploadStatus: builder.query({
      query: (jobId) => ({
        url: `${inmobiusJobApiVersion}/offline-responses/get-offline-upload-status`,
        method: "GET",
        params: {
          job_id: jobId,
        },
        headers: {
          "product-id": "100",
          "tenant-id": "99999",
        },
      }),
    }),
    bulkEventReschedule: builder.mutation({
      query: ({ schoolId, uploadedBy, formData }) => ({
        url: `${inmobiusJobApiVersion}/data-imports/reschedule-events/`,
        method: "POST",
        params: {
          school_id: schoolId,
          uploaded_by: uploadedBy,
        },
        body: formData,
      }),
    }),
    bulkEventDelete: builder.mutation({
      query: ({ formData }) => ({
        url: `${inmobiusJobApiVersion}/data-imports/delete-events`,
        method: "POST",
        params: {
          api_secret_key: apiKey,
        },
        body: formData,
      }),
    }),
    bulkUploadOfflineResponses: builder.mutation({
      query: ({ formData }) => ({
        url: `${inmobiusJobApiVersion}/offline-responses/upload-offline-response-csv`,
        method: "POST",
        body: formData,
      }),
    }),
    getBulkJobLogs: builder.query({
      query: (payload) => ({
        url: `${inmobiusJobApiVersion}/data-imports/bulk-job-logs`,
        method: "POST",
        body: payload,
      }),
    }),
    getJobRecords: builder.query({
      query: (payload) => ({
        url: `${inmobiusJobApiVersion}/data-imports/job-records/${payload.jobId}?job_type=${payload.jobType}&record_status=${payload.status}`,
        method: "GET",
      }),
    }),
    bulkRegisterGlobalEvents: builder.mutation({
      query: ({ formData }) => ({
        url: `${inmobiusJobApiVersion}/data-imports/bulk-register-global-events`,
        method: "POST",
        body: formData,
      }),
    }),
  }),
});

export const {
  useBulkRegisterMutation,
  useBulkUpdateMutation,
  useGetBulkRecordStatusQuery,
  useBulkEventRescheduleMutation,
  useBulkEventDeleteMutation,
  useBulkUploadOfflineResponsesMutation,
  useGetOfflineUploadStatusQuery,
  useGetBulkJobLogsQuery,
  useGetJobRecordsQuery,
  useBulkRegisterGlobalEventsMutation,
} = uploadMutation;
